import { createContext } from 'react';

import {
  Media,
  MediaFolder,
  MediaFolderTree,
  MediaType,
} from '@atom/types/media';

import { FilesData } from './types';

type Context = {
  folderTree: MediaFolderTree | undefined;
  folders: MediaFolder[];
  media: Media[];
  foldersLoading: boolean;
  mediaLoading: boolean;
  uploadAndRefetch: (data: FilesData) => Promise<unknown>;
  downloadSelected: (selectedMedia: Media[]) => Promise<void>;
  canCreate: boolean;
  canUpdate: boolean;
  canDelete: boolean;
  selectedFolderId: string;
  selectedFolder: MediaFolderTree | null;
  selectedFolderDepth: number;
  selectedMediaType: MediaType | null;
  selectedItems: Set<string>;
  selectFolder: (folderId: string) => void;
  toggleSelectItem: (id: string) => void;
  clearSelection: () => void;
  onMoveComplete: (movedFromId: string, destId: string) => void;
  createFolder: (parentFolderId: string, name: string) => void;
  editFolder: (folderId: string, name: string) => void;
  deleteFolder: (folderId: string) => void;
  moveFolder: (id: string, destParentFolderId: string) => Promise<unknown>;
  moveMedia: (mediaIds: string[], destFolderId: string) => Promise<unknown>;
  renameMedia: (id: string, name: string) => void;
  deleteMedia: (id: string) => void;
};

export const initialState: Context = {
  folderTree: undefined,
  folders: [],
  media: [],
  foldersLoading: false,
  mediaLoading: false,
  uploadAndRefetch: () => Promise.resolve(undefined),
  downloadSelected: () => Promise.resolve(),
  canCreate: false,
  canUpdate: false,
  canDelete: false,
  selectedFolderId: '',
  selectedFolder: null,
  selectedFolderDepth: 0,
  selectedMediaType: null,
  selectedItems: new Set(),
  selectFolder: () => {},
  toggleSelectItem: () => {},
  clearSelection: () => {},
  onMoveComplete: () => {},
  createFolder: () => {},
  editFolder: () => {},
  deleteFolder: () => {},
  moveFolder: () => Promise.resolve(),
  moveMedia: () => Promise.resolve(),
  renameMedia: () => {},
  deleteMedia: () => {},
};

const FilesTabContext = createContext<Context>(initialState);

export default FilesTabContext;
